import { Button, Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Transfer, { TransferDirection } from 'antd/es/transfer';
import { CustomInput } from 'components/custom';
import { useFormik } from 'formik';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { encode } from 'querystring';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DELETE, PUT } from '../../../utils';
import GeneralHeader from 'components/common/GeneralHeader';

const ChangeModel = () => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [listTasksData, setListTasksData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { successNotification, errorNotification } = useNotice();
  const { getTaskOption } = useMember();

  const data = location.state?.data;
  const formik = useFormik({
    initialValues: {
      id: data?.id,
      title: data?.title,
    },
    onSubmit: (data: any) => {
      PUT('/api/boarding-model/update/', data)
        .then((res) => {
          if (res.status === 200) {
            navigate('/boarding_management/change_a_model_succeed', {
              state: { title: data.title },
            });
          }
        })
        .catch((e) => errorNotification('This model has been existed!'));
    },
  });

  useEffect(() => {
    getTaskOption().then((response) => {
      setListTasksData(
        response?.data?.map((item) => {
          return {
            key: item.id,
            title: item.title,
            model_type: item.model_type,
          };
        }),
      );
    });
  }, []);

  useEffect(() => {
    setTargetKeys(
      data?.tasks.map((task) => {
        return task.id;
      }),
    );
  }, [data]);

  const onChange = (
    nextTargetKeys: string[],
    direction: TransferDirection,
    moveKeys: string[],
  ) => {
    setTargetKeys(nextTargetKeys);
    formik.setFieldValue('task_ids', nextTargetKeys);
  };

  const onSelectChange = (
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[],
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const onDelete = async (id: number) => {
    const param = { ids: id };
    await DELETE(`/api/boarding-model/delete/?${encode(param)}`).then((res) => {
      if (res.status === 204) {
        navigate('/boarding_management');
        successNotification('This model deleted successfully.');
      }
    });
  };

  return (
    <GeneralHeader
      child={
        <Form onFinish={formik.handleSubmit}>
          <div
            style={{
              fontWeight: '700',
              marginTop: '40px',
              fontSize: '24px',
            }}
          >
            Change a model
          </div>
          <div style={{ display: 'flex', marginTop: '50px', gap: 4 }}>
            <div>Model Type</div>
            <div style={{ color: '#E02C2C' }}>*</div>
          </div>
          <div
            style={{
              maxWidth: '112px',
              height: '26px',
              background:
                data.model_type === 'on_boarding' ? '#B3F9CF' : ' #FFB5B5',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 16px',
              marginTop: '1em',
            }}
          >
            {data.model_type === 'on_boarding' ? 'Onboarding' : 'Offboarding'}
          </div>
          {/* FIRST BLOCK*/}
          <div style={{ marginTop: '50px' }} className={'leave_request_form'}>
            <CustomInput
              background="#FFFFFF"
              defaultValue={data?.title}
              width="100%"
              title="Title of model"
              required
              onChange={(s) => formik.setFieldValue('title', s.target.value)}
              fontSize={12}
              maxLength={100}
            />
            <div
              style={{ marginTop: '20px' }}
              className="on_boarding_creation_task_text_area"
            >
              <div
                style={{
                  margin: '16px 16px 0px 10px',
                  fontWeight: '400',
                  fontSize: '10px',
                  lineHeight: '16px',
                  color: '#898989',
                }}
              >
                Description
              </div>
              <TextArea
                style={{
                  fontFamily: 'IBM Plex Serif',
                  fontWeight: '400',
                  fontSize: '12px',
                  color: '#000',
                }}
                defaultValue={data?.description}
                bordered={false}
                rows={6}
                onChange={(s) =>
                  formik.setFieldValue('description', s.target.value)
                }
                maxLength={200}
              />
            </div>
          </div>
          {/* SECOND BLOCK*/}
          <div
            style={{ marginTop: '50px', marginBottom: '50px ' }}
            className={'leave_request_form'}
          >
            <Transfer
              dataSource={listTasksData.filter(
                (item) => item.model_type === data.model_type,
              )}
              titles={['All tasks', 'Selected tasks']}
              showSearch
              showSelectAll={false}
              targetKeys={targetKeys}
              selectedKeys={selectedKeys}
              onChange={onChange}
              onSelectChange={onSelectChange}
              listStyle={{
                width: '50%',
                height: 400,
                background: 'white',
                fontSize: 12,
              }}
              onSearch={() => {}}
              render={(item) => item.title}
            />
          </div>
          <div
            style={{
              display: 'flex',
              float: 'right',
              gap: 16,
              marginTop: 50,
              marginBottom: 50,
              paddingRight: 80,
            }}
          >
            <Button
              onClick={() => navigate(-1)}
              style={{
                background: 'white',
                color: '#407FDD',
                width: 145,
                height: 50,
                border: 'none',
                borderRadius: 20,
                fontSize: '16px',
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={() => onDelete(data?.id)}
              style={{
                background: '#FFE1E1',
                color: '#EF6C6C',
                width: 145,
                height: 50,
                border: 'none',
                borderRadius: 20,
                fontSize: '16px',
              }}
            >
              DELETE
            </Button>
            <Button
              htmlType="submit"
              type={'primary'}
              style={{
                background: '#407FDD',
                width: 145,
                height: 50,
                border: 'none',
                color: '#FFFFFF',
                borderRadius: 20,
                fontSize: '16px',
              }}
            >
              MODIFY
            </Button>
          </div>
        </Form>
      }
    />
  );
};

export default ChangeModel;
